import { useToasted } from '@hoppscotch/vue-toasted'
import { ref } from 'vue'

import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'

export function useAddToCart() {
  const toasted = useToasted()
  const { getSiteCopy } = useContentfulComponent()

  const addedToCartText = ref(
    getSiteCopy('copyGroupCommon', 'copyItemAddedToCartNotificationText') ||
      'Product(s) Added to Cart',
  )

  function showToastOnAddToCart(responseEntry, productTitle) {
    const isAddedToCart = responseEntry.statusCode === 'success'
    const title = responseEntry.entry?.product?.name || productTitle || ''
    const toastedData = {
      icon: isAddedToCart ? 'icon icon-checkmark' : 'icon-exclamation-triangle',
      className: isAddedToCart ? 'toasted--success' : 'toasted--error',
      message: isAddedToCart
        ? addedToCartText.value
        : `${title} ${this.$t('orders.reorderModal.notAddedText')}: ${
            responseEntry.statusMessage || ''
          }`,
    }
    toasted.show(toastedData.message, {
      icon: {
        name: toastedData.icon,
      },
      className: toastedData.className,
      duration: 6000,
    })
  }
  return {
    showToastOnAddToCart,
  }
}
